import { usePushGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event';
import { CustomGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event/payloads';
import Select, { OnChangeValue } from 'react-select';
import { ValueSet, ValueSetId } from '@upright/common/model/input/value-sets/types';
import {
  CUSTOM_VALUE_SET_NAME,
  nirValueSets,
  valueSetsToShowTeam,
  valueSetsToShowUsers,
} from '@upright/common/model/input/value-sets/value-sets';
import { useIsTeam } from '../../../../generic/hooks';
import { inlineSelectStyles } from '../../../../generic/utilities/selectStyles';
import { useValuesSelectorContext } from './context';
import { CustomDropdownOption, OptionType } from './custom-dropdown-option';
import { CustomMenuList } from './custom-menulist';

export function Dropdown() {
  const isTeam = useIsTeam();

  const context = useValuesSelectorContext();
  const valueSet = context.selectedValueSet;
  const options = getOptions(valueSet?.valueSet, isTeam);
  const selectedOption = options.find(d => d.label === valueSet?.name);
  const pushGtmEvent = usePushGtmEvent();

  return (
    <Select
      components={{
        Option: CustomDropdownOption,
        MenuList: CustomMenuList,
      }}
      placeholder="Select value set..."
      value={selectedOption}
      styles={{
        ...inlineSelectStyles,
        control(base, state) {
          const control = inlineSelectStyles.control;
          if (!control) {
            return {};
          } else {
            return { ...control(base, state), cursor: 'pointer' };
          }
        },
      }}
      options={options}
      isMulti={false}
      onChange={(selection: OnChangeValue<OptionType, false>) => {
        if (selection) {
          pushGtmEvent({
            event: CustomGtmEvent.VALUE_SET_PRESET_SELECT,
            data: {
              preset: selection.label,
            },
          });
          context.setSelectedValueSet({ valueSet: selection.valueSet, name: selection.label });
        }
      }}
    />
  );
}

function getOptions(customValueSet: ValueSet | undefined, isTeam: boolean): OptionType[] {
  if (!customValueSet) {
    return [];
  }

  const valueSets = isTeam ? valueSetsToShowTeam : valueSetsToShowUsers;

  const predefinedOptions = valueSets.map(d => ({
    label: d.title,
    value: d.title,
    valueSet: d.valueSet,
    description: d.description,
  }));

  const nonPredefinedValueSetOptions = isTeam ? getNirOptions() : [];
  const customOption = {
    label: CUSTOM_VALUE_SET_NAME,
    value: CUSTOM_VALUE_SET_NAME,
    description: 'Weights customized by you.',
    valueSet: customValueSet,
  };

  return [...predefinedOptions, ...nonPredefinedValueSetOptions, customOption];
}

function getNirOptions(): OptionType[] {
  return (Object.keys(nirValueSets) as ValueSetId[]).map(k => ({
    label: k,
    value: k,
    description: 'Internal team value set from NIR',
    valueSet: nirValueSets[k],
  }));
}
